import { BETTERFLY_DOMAIN, GOBETTERFLY_DOMAIN } from '../../constants/constants';
import { ADMIN_PROPERTIES, SET_ACTION } from '../../constants/tagManager';
import { IUserHolding } from '../../interfaces/businessData';
import TagManagerService from '../../services/gtm/tagManagerService';

export const getUserProps = (userHoldings: IUserHolding[]) => {
  const companiesIdList: string[] = [];
  const companiesNameList: string[] = [];
  const auxCompaniesRoles: Set<string> = new Set();
  const externalIdList: string[] = [];

  for (const holding of userHoldings) {
    for (const company of holding.companies) {
      companiesIdList.push(company.id);
      companiesNameList.push(company.name);
      auxCompaniesRoles.add(company.role?.name ?? 'unknown');
      if (company.externalId) {
        externalIdList.push(company.externalId);
      }
    }
  }

  const companiesRolesList = [...auxCompaniesRoles];
  return { companiesIdList, companiesRolesList, companiesNameList, externalIdList };
};

export const sendUserPropsToGtm = (
  userCompanies: string[],
  userRoles: string[],
  userEmail: string,
  externalIdList: string[],
  userIsNewExperience = false
) => {
  const isBetterflyer = userEmail.endsWith(BETTERFLY_DOMAIN) || userEmail.endsWith(GOBETTERFLY_DOMAIN);
  const adminPropsGtm = {
    admin_companies: userCompanies,
    admin_roles: userRoles,
    email: userEmail,
    new_experience: userIsNewExperience,
    companies_external_id: externalIdList,
    is_betterflyer: isBetterflyer
  };

  TagManagerService.pushAllEvents(SET_ACTION, ADMIN_PROPERTIES, adminPropsGtm);
};
